module.exports = __webpack_public_path__ + "static/mstile-310x150-202513aeba13e000ee7b2a834c1f77d8.png";